import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 16C8 16.5523 8.44772 17 9 17C9.55228 17 10 16.5523 10 16C10 13.6915 10.5108 12.2576 11.3842 11.3842C12.2576 10.5108 13.6915 10 16 10C16.5523 10 17 9.55228 17 9C17 8.44772 16.5523 8 16 8C13.6915 8 12.2576 7.48919 11.3842 6.61581C10.5108 5.74243 10 4.30849 10 2C10 1.44772 9.55228 1 9 1C8.44772 1 8 1.44772 8 2C8 4.30849 7.48919 5.74243 6.61581 6.61581C5.74243 7.48919 4.30849 8 2 8C1.44772 8 1 8.44772 1 9C1 9.55228 1.44772 10 2 10C4.30849 10 5.74243 10.5108 6.61581 11.3842C7.48919 12.2576 8 13.6915 8 16Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.5 22C16.5 22.5523 16.9477 23 17.5 23C18.0523 23 18.5 22.5523 18.5 22C18.5 20.5596 18.8198 19.7506 19.2852 19.2852C19.7506 18.8198 20.5596 18.5 22 18.5C22.5523 18.5 23 18.0523 23 17.5C23 16.9477 22.5523 16.5 22 16.5C20.5596 16.5 19.7506 16.1802 19.2852 15.7148C18.8198 15.2494 18.5 14.4404 18.5 13C18.5 12.4477 18.0523 12 17.5 12C16.9477 12 16.5 12.4477 16.5 13C16.5 14.4404 16.1802 15.2494 15.7148 15.7148C15.2494 16.1802 14.4404 16.5 13 16.5C12.4477 16.5 12 16.9477 12 17.5C12 18.0523 12.4477 18.5 13 18.5C14.4404 18.5 15.2494 18.8198 15.7148 19.2852C16.1802 19.7506 16.5 20.5596 16.5 22Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }